var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDragging)?_c('div',{staticClass:"draggable-event",style:(_vm.dragStyles)},[_c('Event',_vm._b({attrs:{"date":_vm.newDate || _vm.event.date}},'Event',_vm.event,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }